export default __webpack_public_path__ + "static/media/cold-tea.2ff58ef6.png";